import { render } from "./ProductBuild.vue?vue&type=template&id=5f50ff50&scoped=true"
import script from "./ProductBuild.vue?vue&type=script&lang=js"
export * from "./ProductBuild.vue?vue&type=script&lang=js"

import "./ProductBuild.vue?vue&type=style&index=0&id=5f50ff50&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f50ff50"]])

export default __exports__